export const getLocationFields = (data, t) => {
  const locationFields = [
    {
      key: 'address',
      value: data?.location?.address,
      emptyLabel: t('professionalPubli.edition.card.empty.address')
    },
    {
      key: 'subzone',
      value: data?.location?.subzone || null,
      emptyLabel: t('professionalPubli.edition.card.empty.subzone')
    },
    {
      key: 'zone',
      value: data?.location?.zone,
      emptyLabel: t('professionalPubli.edition.card.empty.zone')
    },
    {
      key: 'city',
      value: data?.location?.city,
      emptyLabel: t('professionalPubli.edition.card.empty.city')
    },
    {
      key: 'province',
      value: data?.location?.province,
      emptyLabel: t('professionalPubli.edition.card.empty.province')
    }
  ];

  const visibleFields = locationFields.filter(field => field.value !== null && field.value !== undefined);

  return {
    visibleFields,
    locationFields
  };
};
